import { motion } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";

export const ManifestoChapters = () => {
  const { t } = useLanguage();
  return (
    <section id="manifesto" className="py-20 sm:py-28 bg-[#FAF7F2]">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <motion.p initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.5 }}
          className="text-xs font-mono uppercase tracking-[0.22em] text-[#C85A17] font-semibold">
          {t.manifesto.overline}
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1 }}
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#17181A] mt-4 mb-14 sm:mb-20" data-testid="manifesto-heading">
          {t.manifesto.heading}
        </motion.h2>
        <div className="space-y-0">
          {t.manifesto.chapters.map((ch, i) => (
            <motion.div key={ch.num}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-12 gap-4 sm:gap-8 py-10 sm:py-12 border-t border-[#E7DFD5] last:border-b items-start"
              data-testid={`manifesto-chapter-${ch.num}`}>
              <div className="col-span-3 sm:col-span-2">
                <span className="font-mono text-sm text-[#C85A17] tracking-widest">/{ch.num}</span>
              </div>
              <div className="col-span-9 sm:col-span-10 grid sm:grid-cols-2 gap-4 sm:gap-10">
                <h3 className="font-serif text-xl sm:text-2xl leading-snug text-[#17181A] group-hover:text-[#C85A17] transition-colors duration-300">
                  {ch.title}
                </h3>
                <p className="text-sm sm:text-base leading-relaxed text-[#5F6368]">{ch.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
